import React from "react";
import { SvgIcon } from "@mui/material";

const TikTokIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64c.298-.002.595.042.88.13V9.4a6.33 6.33 0 00-1-.08A6.34 6.34 0 003 15.66a6.34 6.34 0 0010.86 4.48l.13-.19V22h3.45v-6.58a1.45 1.45 0 01-.08-.42V7.75a8.17 8.17 0 005.52 2.16V6.43a4.84 4.84 0 01-3.29.26z"
    />
  </SvgIcon>
);

export default TikTokIcon;
